import type React from 'react';
import styled from 'styled-components';

const StyledMenuRowWrapper = styled.div`
  display: flex;
  align-items: stretch;
`;
const StyledMenuRowContent = styled.div`
  flex: 0 0 auto;
  min-height: 0px;
  min-width: 0px;
  margin-left: 24px;
`;
const StyledMenuRowExtra = styled.div`
  flex: 1 1 auto;
  min-height: 0px;
  min-width: 0px;
  border-bottom: 1px solid ${({ theme }) => theme.colorSplit};
`;

export interface RichTextFooterRowProps {
  extra?: React.ReactNode;
  children: React.ReactNode;
}

export function RichTextFooterRow(props: RichTextFooterRowProps) {
  const { extra, children } = props;
  return (
    <StyledMenuRowWrapper>
      <StyledMenuRowExtra>{extra}</StyledMenuRowExtra>
      <StyledMenuRowContent>{children}</StyledMenuRowContent>
    </StyledMenuRowWrapper>
  );
}
